import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { LanguageServiceService } from '../../services/language-service.service';
import { LanguagesService } from '../../services/languages.service';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoginService } from '../../components/Authentication/auth/login.service';
import { LogoutService } from '../../components/Authentication/auth/logout.service';


import { UserService } from '../../services/user';
import { PetsService } from '../../services/pets';
import { TranslocoService } from '@ngneat/transloco';
import { AccountTypeService } from '../../services/account-type';
import { WarehouseTypeService } from '../../services/warehouse-type';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @Input() isActive!: boolean;

  warehouseId = localStorage.getItem('posId');

  constructor(
    public accountService: AccountTypeService,
    public warehouseService: WarehouseTypeService,
    private router: Router
  ) {

  }

  ngOnInit(): void {
    this.refreshHeaderContext();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.refreshHeaderContext();
      }
    });
  }

  private refreshHeaderContext(): void {
    const posId = Number(localStorage.getItem('posId'));

    if (posId) {
      this.warehouseService.getWarehouseType(posId).subscribe({
        next: () => {}
      });
    }

    this.accountService.getAccountType().subscribe();
  }



}
